import React from "react";
import Owner from "assets/images/svg/ticket_owner.svg";
import { EventStatus, TicketLog, TicketTopicEnum, useTicketDetail } from "pages/tickets/ticket.service";
import { Spinner } from "react-bootstrap";
import { useQuery } from "react-query";
import { client } from "helpers/client";
import { formatDate, json } from "helpers/data";
import { useAuthContext } from "store/auth";
import { useTranslation } from "react-i18next";

interface TicketDetailsComponentProps {
  ticketId: string;
}

function TicketLogsComponent({ ticketId }: any) {
  const { t } = useTranslation("tickets");
  const [{ user }] = useAuthContext();
  const { data, isLoading } = useQuery(["ticket-logs"], async () => {
    const { response } = await client<string>("/ticket/getTicketLogs", { params: { ticketId } });
    if (response) return JSON.parse(response) as TicketLog[];
  });
  return (
    <div className="ticketLog">
      <h1 className="title">{t("ticket-log")}</h1>
      {isLoading && <Spinner animation="border" />}
      {data?.map((log) => (
        <div key={log.Id} className="box-log">
          <div className="info">
            <h2>{t(EventStatus[log.EventId])}</h2>
            <span>{formatDate(log.LogDate, { showTime: true })}</span>
          </div>
          <p>
            {t(EventStatus[log.EventId])} {t("by")} {log.IsChangeByCustomer ? user.Name : log.EventBy}
            {log.ToAgent ? "to " + log.ToAgent : null}
          </p>
        </div>
      ))}
    </div>
  );
}

function TicketDetailsComponent({ ticketId }: TicketDetailsComponentProps) {
  const { t } = useTranslation("tickets");
  const [{ user }] = useAuthContext();
  const { ticket, isLoading } = useTicketDetail(ticketId);

  if (isLoading) return <Spinner animation="border" />;
  if (!ticket) return null;
  return (
    <div className="ticket-right-side">
      <div className="box-header">
        <h1>{t("ticket-info")}</h1>
        <span className="status">{ticket.status}</span>
      </div>
      <div className="box-info">
        <p>
          {t("ticket-id")}: <span># {ticket.serial}</span>
        </p>
        <p className="dimmed">
          {t("created")}: <span className="dark ">{formatDate(ticket.createDate, { showTime: true })}</span>
        </p>
        <p className="dimmed">
          {t("last-updated")}: <span className="dimmed">{formatDate(ticket.updateDate, { showTime: true })}</span>
        </p>
        <p className="dimmed">
          {t("title")}: <span className="dark">{ticket.title}</span>
        </p>
      </div>
      <div className="box-description">
        <h2>{t("description")}</h2>
        <p>{ticket.description}</p>
        {ticket.topicId === TicketTopicEnum.TechnicalSupport && (
          <>
            <p className="dimmed">
              Topic: <span className="dark">{t("technical-support")}</span>
            </p>
            <p className="dimmed">
              {t("product")}: <span className="dark">{json(ticket.product)}</span>
            </p>
            <p className="dimmed">
              {t("subject")}: <span className="dark">{ticket.subject}</span>
            </p>
            <p className="dimmed">
              {t("priority")}: <span className="dark">{ticket.priority}</span>
            </p>
          </>
        )}
        {ticket.topicId === TicketTopicEnum.Billing && (
          <p className="dimmed">
            Topic: <span className="dark">{t("billing")}</span>
          </p>
        )}
        {/*<p className='dimmed'>Attachments </p>*/}
        {/*{ticket.attachments?.length || <p className='dark'>There is no attachment here in this ticket</p>}*/}

        {/*<div className='person mb-5'>*/}
        {/*{ticket.attachments?.map(file =>   <img className="img-person" src={`data:${file.MimeType};base64,` + file.FileBase64} alt="attach-file"/>)}*/}
        {/*</div>*/}
      </div>
      <h1 className="title">{t("stakeholders")}</h1>

      <div className="person">
        <div className="box-person">
          <img className="img-person" src={Owner} alt="person" />
          <h3 className="name">{user.Name}</h3>
          <h6 className="personType">Customer</h6>
        </div>
        <div className="box-person">
          <img className="img-person" src={Owner} alt="person" />
          <h3 className="name">{ticket.agent?.name}</h3>
          <h6 className="personType">{ticket.agent?.title}</h6>
        </div>
      </div>

      <div className="owner">
        <h1 className="title">{t("owners")}</h1>
        {ticket.owners.map((owner) => (
          <div key={owner.id} className="box-owner">
            <div className="info">
              <img src={Owner} alt="owner" />
              <h2 className="name">{owner.name}</h2>
            </div>
            <span>{owner.title}</span>
          </div>
        ))}
      </div>

      <TicketLogsComponent ticketId={ticketId} />
    </div>
  );
}

export default TicketDetailsComponent;
